export const REQUIRED_ONBOARDING = 'REQUIRED_ONBOARDING';
export const PROMOTIONS = 'PROMOTIONS';
export const PRODUCTS = 'PRODUCTS';
export const OWNERSHIP = 'OWNERSHIP';
export const RETAIL = 'RETAIL';
export const CONTACTS = 'CONTACTS_IN_CRM';
export const MARKETING_CONTACTS = 'MARKETING_CONTACTS';
export const PHONE_NUMBERS = 'PHONE_NUMBERS';
export const SETTINGS = 'SETTINGS';
export const PURCHASE_MOTIONS = 'PURCHASE_MOTIONS';
export const PUBLIC = 'PUBLIC_META_DATA';
export const COUNTRY = 'COUNTRY';
export const PRODUCT_INVENTORY = 'PRODUCT_INVENTORY';
export const FEATURES = 'FEATURES';
export const COMPARE = 'COMPARE';
export const BUSINESS_OBJECTIVES = 'BUSINESS_OBJECTIVES';